function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { config } from "../config";
import { getLogger } from "./logger";
import { getRevision } from "./revision";
var apiProxyUrl = config.apiProxyUrl;
var scheme = "https?://";
var domain = "(serverless|runtime).vonage.[^/]+";
var log = getLogger("PROXY");
// Temporary check whether endpoint is reachable through proxy
var isProxy = false;
export var getIsProxy = function() {
    return isProxy;
};
export var checkProxy = function() {
    var _ref = _async_to_generator(function() {
        var isCustomerDashboard, isCloudRuntime, isProxyFeature, response, code, isNumber, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    isCustomerDashboard = getRevision().appName === "customer";
                    isCloudRuntime = getRevision().appName === "market";
                    isProxyFeature = localStorage.getItem("vch.feat.proxy");
                    // Enabled unless set otherwise
                    if (isCustomerDashboard) {
                        if (isProxyFeature === "false") {
                            return [
                                2,
                                false
                            ];
                        }
                    }
                    // Disabled unless set otherwise
                    if (isCloudRuntime) {
                        if (isProxyFeature !== "true") {
                            return [
                                2,
                                false
                            ];
                        }
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch("".concat(window.location.origin, "/neru/api/v1/euw1/marketplace/_health"))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    code = _state.sent();
                    isNumber = !isNaN(Number(code));
                    if (isNumber) {
                        log.info("Proxy is enabled");
                        isProxy = true;
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    log.warn("Proxy returned status: ".concat(response.status));
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    log.warn("Proxy is off. Error: ".concat(error));
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function checkProxy() {
        return _ref.apply(this, arguments);
    };
}();
export var mapApiRoute = function(route) {
    if (!apiProxyUrl || !route || !isProxy) {
        return route;
    }
    {
        var regex = new RegExp("^".concat(scheme, "(cs-[^.]+).([^.]+).*").concat(domain, "$"));
        // First check CodeServer pattern (workspace launch URL) since it's pattern
        // is different
        if (regex.test(route)) {
            var result = route.replace(regex, function(_, group1, group2) {
                var proxyUrl = apiProxyUrl.replace("$1", group2 || "");
                return [
                    proxyUrl,
                    "cs/".concat(group1, "/")
                ].join("/");
            });
            return "".concat(result, "?folder=/home/coder/project");
        }
    }
    var _obj;
    var patterns = (_obj = {}, _define_property(_obj, "^".concat(scheme, "deployment-api.([^.]+).*").concat(domain, "/(.*)"), "deployment/$3"), _define_property(_obj, "^".concat(scheme, "marketplace-api.([^.]+).*").concat(domain, "/(.*)"), "marketplace/$3"), _define_property(_obj, "^".concat(scheme, "vonage-assets.([^.]+).*").concat(domain, "/(.*)"), "assets/$3"), _define_property(_obj, "^".concat(scheme, "graphql.([^.]+).*").concat(domain, "/v1/graphql"), "$2/graphql"), _define_property(_obj, "^".concat(scheme, "vcr-subscriptions-service.([^.]+).*").concat(domain, "/(.*)"), "subscriptions/$3"), _obj);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(patterns)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), pattern = _step_value[0], replacement = _step_value[1];
            var regex1 = new RegExp(pattern);
            if (regex1.test(route)) {
                return route.replace(regex1, [
                    apiProxyUrl,
                    replacement
                ].join("/"));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return route;
};

//# sourceMappingURL=api-routes-mapper.js.map